import { type MenuItem } from '@/types/common';
import IcCrMark from '@/assets/icons/CrMark.svg?react';
import IcCreditCardSimple from '@/assets/icons/CreditCardSimple.svg?react';
import IcDashboard from '@/assets/icons/Dashboard.svg?react';
import IcExit from '@/assets/icons/Exit.svg?react';
import IcFilePen from '@/assets/icons/FilePen.svg?react';
import IcFileRedact from '@/assets/icons/FileRedact.svg?react';
import IcFileText from '@/assets/icons/FileText.svg?react';
import IcFolderOpen from '@/assets/icons/FolderOpen.svg?react';
import IcFileArchive from '@/assets/icons/FileArchive.svg?react';
import IcFileClock from '@/assets/icons/FileClock.svg?react';
import IcFileCheck from '@/assets/icons/FileCheck.svg?react';
import IcFileStack from '@/assets/icons/FileStack.svg?react';
import IcFileX from '@/assets/icons/FileX.svg?react';
import IcMerge from '@/assets/icons/Merge.svg?react';
import IcReceipt from '@/assets/icons/Receipt.svg?react';
import IcSettings from '@/assets/icons/Settings.svg?react';
import IcShieldCheck from '@/assets/icons/ShieldCheck.svg?react';
import IcSupport from '@/assets/icons/Support.svg?react';
import IcTools from '@/assets/icons/Tools.svg?react';
import IcUser from '@/assets/icons/User.svg?react';
import IcUsers from '@/assets/icons/Users.svg?react';

const menuApp = (
  [
    {
      icon: IcDashboard,
      label: 'common:menu.dashboard',
      href: '/dashboard',
      refreshOnSameClick: true,
      primaryMobile: true,
    },
    {
      icon: IcUsers,
      label: 'common:menu.contacts',
      href: '/contacts',
      refreshOnSameClick: true,
      primaryMobile: true,
    },
    {
      icon: IcShieldCheck,
      label: 'common:menu.safeTransfer',
      href: '/safe-transfer',
      refreshOnSameClick: true,
      mobileSection: 'workspace',
    },
    {
      icon: IcFileStack,
      label: 'common:menu.templates',
      href: '/templates',
      refreshOnSameClick: true,
      mobileSection: 'workspace',
    },
    {
      icon: IcFolderOpen,
      label: 'common:menu.signings',
      href: '/signings',
      refreshOnSameClick: true,
      primaryMobile: true,
      submenuItems: [
        {
          icon: IcFilePen,
          label: 'common:menu.signings.draft',
          href: '/signings/draft',
          refreshOnSameClick: true,
        },
        {
          icon: IcFileText,
          label: 'common:menu.signings.pending',
          href: '/signings/pending',
          refreshOnSameClick: true,
        },
        {
          icon: IcFileCheck,
          label: 'common:menu.signings.done',
          href: '/signings/done',
          refreshOnSameClick: true,
        },
        {
          icon: IcFileClock,
          label: 'common:menu.signings.expired',
          href: '/signings/expired',
          refreshOnSameClick: true,
        },
        {
          icon: IcFileX,
          label: 'common:menu.signings.cancelled',
          href: '/signings/cancelled',
          refreshOnSameClick: true,
        },
      ],
    },
    {
      icon: IcTools,
      label: 'common:menu.tools',
      href: '/tools',
      submenuItems: [
        {
          icon: IcMerge,
          label: 'common:menu.pdfMerge',
          href: '/tools/pdf-merge',
          mobileSection: 'tools',
        },
        {
          icon: IcFileArchive,
          label: 'common:menu.pdfToPdfA',
          href: '/tools/pdfa-conversion',
          mobileSection: 'tools',
        },
        {
          icon: IcFileText,
          label: 'common:menu.docxToPdf',
          href: '/tools/docx-conversion',
          mobileSection: 'tools',
        },
        {
          icon: IcFileRedact,
          label: 'common:menu.redactPdf',
          href: '/tools/redact',
          mobileSection: 'tools',
        },
      ],
    },
    {
      // C2PA POC — only shown when the backend reports the feature enabled
      // (filtered in AppLayout via the c2pa.status endpoint).
      icon: IcCrMark,
      label: 'common:menu.contentCredentials',
      href: '/content-credentials',
      refreshOnSameClick: true,
      mobileSection: 'workspace',
    },
    {
      icon: IcUser,
      label: 'common:menu.profile',
      href: '/account',
      mobileSection: 'profile',
      submenuItems: [
        {
          icon: IcUsers,
          label: 'common:menu.members',
          href: '/account/members',
          refreshOnSameClick: true,
          mobileSection: 'profile',
        },
        {
          icon: IcCreditCardSimple,
          label: 'common:menu.subscription',
          href: '/account/subscription',
          mobileSection: 'profile',
        },
        {
          icon: IcReceipt,
          label: 'common:menu.invoicing',
          href: '/account/invoicing',
          mobileSection: 'profile',
        },
      ],
    },
    {
      icon: IcSettings,
      label: 'common:menu.settings',
      href: '/settings',
      mobileSection: 'help',
    },
    {
      icon: IcSupport,
      label: 'common:menu.support',
      href: 'https://www.swipesign.io/{lang}/support',
      target: '_blank',
      mobileSection: 'help',
    },
    {
      icon: IcExit,
      label: 'common:header.logout',
      href: '/auth/login',
      action: 'logout',
      highlight: true,
    },
  ] as MenuItem[]
).filter(Boolean);

export default menuApp;
